import styled from "@emotion/styled";
import React, { CSSProperties } from "react";
import IconBerserkerMail from "../Icon";
interface IListItemContainer {
  isActive: boolean;
}

const ListItemContainer = styled.div`
  border-bottom: 1px solid #d4d4d4;
  border: 1px solid transparent;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  background-color: ${(props: IListItemContainer) =>
    props.isActive ? "#FFF2E5" : "white"};
  color: ${(props: IListItemContainer) =>
    props.isActive ? "#fb972e" : "#000"};

  :hover {
    background-color: #fff2e5;
    color: #fb972e;
  }
`;

const ListIconContainer = styled.div`
  margin-right: 10px;
`;

const ListItemText = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const ListSuffixContainer = styled.div`
  color: #999;
`;

interface Props {
  groupName?: string;
  name: string;
  icon?: string;
  suffix?: string;
  isActive: boolean;
  alreadyWritten: string;
  onClick: () => void;
  customStyle?: CSSProperties;
}

export function AutoCompleteSelectItem(props: Props): JSX.Element {
  const { icon, suffix, name, isActive, customStyle, alreadyWritten, onClick } =
    props;

  const value = alreadyWritten ?? "";
  // This will have an index because it matches
  const startsAt = name.toLowerCase().indexOf(value.toLowerCase());
  return (
    <ListItemContainer
      style={customStyle}
      isActive={isActive}
      onClick={onClick}
    >
      <div style={{ overflowX: "hidden" }}>
        <div style={{ display: "flex" }}>
          {icon && (
            <ListIconContainer>
              <IconBerserkerMail
                name={icon}
                height={16}
                width={16}
                color="#999"
              />
            </ListIconContainer>
          )}
          <ListItemText>{name}</ListItemText>
        </div>
      </div>
      {suffix && <ListSuffixContainer>{suffix}</ListSuffixContainer>}
    </ListItemContainer>
  );
}
